<template>
    <div>
        <Navigation />
        <section class="section__container spacer-8">

            <h1 class="title center__text">Développeur plugins/API (H/F) - Stage</h1>
            <div class="requirements container">
                <h3 class="requirements__title">Un développeur plugins et connecteurs API (H/F) - Stage</h3>
                <h3 class="requirements__title">Profil souhaité :</h3>
                <ul>
                    <li>Formation dans le milieu informatique (Master Informatique, IUT Informatique)</li>
                    <li>Langages maitrisés : PHP/JavaScript/HTML/CSS ainsi que le framework JQuery et <br/>que l’utilisation de l’Ajax</li>
                    <li>Maitrise de Wordpress/Prestashop</li>
                    <li>Maitrise sur l’intégration d’un Webservice</li>
                </ul>
                <h3 class="requirements__title"> Missions :</h3>
                <ul>
                    <li>Développement des connecteurs (plugin, API...)</li>
                    <li>Participer aux missions du service</li>
                    <li>Type de contrat : Stage</li>
                </ul>
                <div class="other__requirements">
                    <h3>Comment postuler ?</h3>
                    <p>Pour candidater à ce poste, veuillez inclure votre CV en l'attachant à un e-mail adressé à

                        <a href="mailto:recrutement@servicesms.sn">recrutement@servicesms.sn</a>
                        , en utilisant comme objet "Développeur plugins/API (H/F) - Stage".
                    </p>

                </div>

            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Navigation from './Navigation';
import Footer from './Footer';
export default {
    components: {
        Navigation,
        Footer
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/base.scss';

.requirements {
    box-shadow: 0 67px 139px 28px rgba(0, 0, 0, .05);
    border-radius: 25px 25px 25px 0;
    
}

.requirements__title {
    padding-left: 2rem;
    padding-top: 1rem;
}

.other__requirements {
    padding-left: 1rem;
    padding-bottom: 4rem;
}

li {
    list-style-type: none;
}

li::before {
    content: "";
    width: 15px;
    height: 15px;
    background: url(../../public/images/picto-list.svg) no-repeat center;
    padding-left: 2rem;
}

@media(min-width: 65rem) {
    .requirements {
        width: 60%;
        margin: 3rem auto;
    }

    .spacer-8 {
        margin-top: 8rem;
    }
    .title{
        padding-top: 3rem;
    }
}</style>